import { useQuery } from "@tanstack/react-query";
import apiClient from "@/services/apiClient";

/**
 * Every bill the clinic has raised, paged — the list endpoint refuses more
 * than a hundred a call and a busy month is more than that. The reports read
 * the month out of it so their figures are the bills' own, not a second tally.
 */
export interface BillRow {
  id: string;
  date?: string;
  status?: string;
  paymentMethod?: string;
  total?: number | string;
  amountPaid?: number | string;
}

const PAGE = 100;

export function useAllBills() {
  return useQuery({
    queryKey: ["accountant", "all-bills"],
    staleTime: 60_000,
    retry: false,
    queryFn: async (): Promise<BillRow[]> => {
      const out: BillRow[] = [];
      for (let page = 1; page <= 12; page += 1) {
        const res = await apiClient.get("/billing", {
          params: { limit: PAGE, page },
        });
        const body =
          (res.data as { data?: BillRow[] | { data?: BillRow[] } })?.data ??
          res.data;
        const batch = (
          Array.isArray(body)
            ? body
            : ((body as { data?: BillRow[] })?.data ?? [])
        ) as BillRow[];
        out.push(...batch);
        if (batch.length < PAGE) break;
      }
      return out;
    },
  });
}
